import { motion, useReducedMotion } from 'framer-motion';

// Minimal, centered, dark-theme preloader: neon ring + 3 orbiting dots
export default function Preloader(): JSX.Element {
  const reduce = useReducedMotion();

  const rotateAnim = reduce
    ? undefined
    : { rotate: 360, transition: { duration: 3.6, ease: 'linear', repeat: Infinity } };

  const dotPulse = (delay = 0) =>
    reduce
      ? undefined
      : { y: [0, -8, 0], transition: { duration: 1.2, repeat: Infinity, ease: 'easeInOut', delay } };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="relative w-44 h-44">
          {/* Rotating neon ring */}
          <motion.div className="absolute inset-0 flex items-center justify-center" animate={rotateAnim} aria-hidden>
            <svg viewBox="0 0 100 100" className="w-40 h-40">
              <defs>
                <radialGradient id="rg2" cx="50%" cy="50%" r="50%">
                  <stop offset="0%" stopColor="#86efac" stopOpacity="0.95" />
                  <stop offset="60%" stopColor="#60a5fa" stopOpacity="0.9" />
                  <stop offset="100%" stopColor="#7c3aed" stopOpacity="0.8" />
                </radialGradient>
              </defs>
              <circle cx="50" cy="50" r="30" stroke="url(#rg2)" strokeWidth="6" fill="none" strokeLinecap="round" className="filter blur-sm" />
              <circle cx="50" cy="50" r="22" stroke="#ffffff10" strokeWidth="1.2" fill="none" />
            </svg>
          </motion.div>

          {/* Orbiting dots container (centered) */}
          <motion.div className="absolute inset-0" animate={reduce ? undefined : { rotate: [0, 120, 240, 360], transition: { duration: 3.6, ease: 'linear', repeat: Infinity } }} aria-hidden>
            {/* top */}
            <motion.span className="absolute left-1/2 top-2 w-3 h-3 bg-white rounded-full shadow-[0_0_12px_rgba(124,58,237,0.8)] -translate-x-1/2" animate={dotPulse(0)} />
            {/* right */}
            <motion.span className="absolute right-2 top-1/2 w-2.5 h-2.5 bg-white/90 rounded-full shadow-[0_0_8px_rgba(96,165,250,0.8)] -translate-y-1/2" animate={dotPulse(0.12)} />
            {/* bottom */}
            <motion.span className="absolute left-1/2 bottom-2 w-2 h-2 bg-white/70 rounded-full shadow-[0_0_6px_rgba(134,239,172,0.7)] -translate-x-1/2" animate={dotPulse(0.24)} />
          </motion.div>
        </div>

        <div className="text-center">
          <div className="text-white text-sm font-semibold">NotesCrafter</div>
          <div className="text-white/70 text-xs mt-1">Loading…</div>
        </div>
      </div>
    </div>
  );
}
